import { QueryClient } from '@tanstack/react-query';

// Polling-driven app: queries refresh via refetchInterval. Intervals pause
// automatically while the tab is hidden (refetchIntervalInBackground defaults
// to false), matching the old useAutoPolling behavior.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 4_000,
            retry: 1,
        },
    },
});
